import type { FaireThemeEntity } from "../../entity_types/theme";

export const under_10_wellness_finds: FaireThemeEntity = {
  token: "under-10-wellness-finds",
  type: "theme",
  name: "Under $10 Wellness Finds",
  description: "Effective, natural remedies that are easy on the budget. Perfect for stocking up your pop-up shop's grab-and-go section.",
  teaser: "As a pop-up store, providing affordable impulse items alongside your clothing and accessories helps increase basket size and introduces customers to your wellness catalog.",
  detail: "The additional_context specifies a theme price anchor of $10.00, and the Immunity Spray sits right below this at a wholesale price of $9.80, making it a low-risk addition to your shop.",
  bgColor: "#D4F0E4",
  tileBgColor: "#6b5831",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_pj8qarvdk9",
    "p_t5uzd8cgjp",
    "p_wte4wggqd9",
    "p_83nqu2qz8s",
    "p_kcf7dvv9nm",
    "p_mna0e5vjkz",
    "p_sek3fdd686",
    "p_mb7pz63w34",
    "p_1rayn3ersx",
    "p_9qq89gknbp",
    "p_2r752r7dbs",
    "p_5gay6r22jg",
    "p_hj3a6587zm",
    "p_ess8runjag",
    "p_ut8jmvuw74",
    "p_u7j6chudtr",
    "p_enhx2t322u",
    "p_rmwq9jrbr9",
    "p_y2bd69pbbq",
    "p_7qpk3n54c5",
    "p_ncgwmju2ve",
    "p_8d525ha9gf",
    "p_h4bd68vx9j",
    "p_9f6wwvssk4",
    "p_y4gba96d8m",
    "p_k6vfyp4geb",
    "p_wtpc3e73jd",
    "p_m4aejqtf99",
    "p_s5bne2bgsd",
    "p_y6kmecnrnv",
    "p_gpg5qyrya5",
    "p_8hhkzjr6xt",
    "p_xzgqsebaec",
    "p_3uwtnp8krr",
    "p_s5c6djgtkt",
    "p_txh8b2c9h6",
    "p_qdt4n6sxab",
    "p_zmn4cmhwkg",
    "p_kb9ws48suu",
    "p_6k4mgqskqn",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
